import { useState } from 'react';
import '@aws-amplify/ui-react/styles.css';
import { Button, Message } from '@aws-amplify/ui-react';
import { Link } from 'react-router-dom';
import { fetchCognitoUserToken } from '../utils/user';

export default function UsersDelete({ user, signOut }) {
  const [deletedUserData, setDeletedUserData] = useState(false);

  return (
    <>
      <main id="users-delete">
        <div>
          <header>
            <Link className="btn ol l-dark go-back" to={'/'}>
              Home
            </Link>
            <h1>Delete My User Data</h1>
            <img src="/icons/logo-circle.svg" alt="wellness logo" className="logo-circle" />
          </header>
          <div>
            <h2>Delete My Data</h2>
            <p>I am hereby requesting all of my data to be deleted from Relentless Health, Inc. systems.</p>

            {deletedUserData && (
              <Message variation="filled" colorTheme="success" heading="Deleted User Data" margin="1rem"></Message>
            )}
            <Button
              onClick={() => {
                deleteUserData(user, setDeletedUserData, signOut);
              }}
              margin="1rem"
            >
              DELETE MY DATA
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}

const deleteUserData = async (user, setDeletedUserData, signOut) => {
  let accessToken = await fetchCognitoUserToken();
  let backendUrl = process.env.REACT_APP_BACKEND_URL;
  let endpoint = backendUrl + '/users/' + user['username'];
  let request_object = {};
  fetch(endpoint, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + accessToken },
    body: JSON.stringify(request_object),
  })
    .then((res) => {
      res.json().then((response) => {
        setDeletedUserData(true);
        signOut();
      });
    })
    .catch((err) => {
      //TODO
    });
};
